// this is an autogenerated file from App/Account/Content/Settings/Content/Onboarding/CsvProcedures/Location/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_Onboarding_CsvProcedures_Location{
  session_user_locations(order_by: { name: asc }) {
    id
    _id
    text: name
  }
}

`